import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <div className="bln-header">
      <Link to="/" className="logo-link">
        <img src="/logo1.png" alt="Logo of CACI in Header" />
      </Link>
      <nav className="navbar">
        <button
          type="button"
          className="menu-toggle"
          aria-label="Toggle navigation menu"
          aria-expanded={menuOpen}
          aria-controls="primary-navigation"
          onClick={() => setMenuOpen((currentValue) => !currentValue)}
        >
          {/* The spans create a hamburger icon */}
          <span />
          <span />
          <span />
        </button>
        <div
          className={`nav-links ${menuOpen ? "nav-links-open" : ""}`}
          id="primary-navigation"
        >
          <NavLink
            to="/archives"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={closeMenu}
          >
            Archives
          </NavLink>
          <NavLink
            to="/about"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={closeMenu}
          >
            About
          </NavLink>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
